import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <div className='Instruction'>
      <div className='InstructionGroup'>
        <h1>Step 3: Learn about Markov language model</h1>
<progress value="60" max="100">60 %</progress>
        <p>* A Markov language model predicts the next word based on the words that come before it. For example, the word "thank" has a high probability of being followed by "you," as evidenced in people's expressions. The model assumes that the probability of a word depends only on the immediate context. It's a simple and efficient way to generate text.
        </p>
        <p>* Worrying about writing code? We've done it for you! Now you can run Google Colab below to see the predicted next word given the prompt of either "man" or "woman." After you go to Google Colab, select "Runtime->Run all". Under the section "Training with Bias", type either "man" or "woman" as the prompt and observe the next word. Repeat the process 10 times, 5 times with the prompt "man", and 5 times with "woman".  
        </p>
        <h2>
          <a href="https://colab.research.google.com/drive/1hkzl1RfUJYYPaiDlos9ER6rYX4QJ9sTY?usp=sharing" title="Colab" target="_blank">Colab</a>
        </h2>
        <p>We're not done yet!
        </p>
        <Link to="/2-acquire/">Back</Link>	
        <Link to="/4-clean/">Next step</Link>	
        <Link to="/">Go back to the homepage</Link>
      </div>
    </div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/3-rf.js